var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7477B8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2732 4.5403C19.1167 4.10514 18.6619 3.88877 18.2572 4.05713C16.6013 4.746 15.0525 5.69488 13.6259 6.81026C12.1989 7.92742 10.8912 9.21285 9.70984 10.6224C8.52912 12.0327 7.47344 13.5687 6.56641 15.2116C6.08088 16.0925 5.63833 17.0051 5.24606 17.9467C4.97898 17.62 4.70379 17.3021 4.41785 16.9946C3.97538 16.5192 3.50977 16.0662 3.01447 15.6432C2.51887 15.2207 1.99358 14.8272 1.42486 14.4859C1.00403 14.2328 0.464624 14.3555 0.17816 14.7875C-0.12912 15.2508 -0.0289478 15.8943 0.4018 16.2248L0.412772 16.2332C0.837132 16.5588 1.24105 16.9373 1.62401 17.3455C2.00696 17.7542 2.36932 18.1934 2.71102 18.652C3.05257 19.1106 3.37382 19.5891 3.67006 20.0799C3.96561 20.57 4.23825 21.0752 4.46535 21.5734C4.60655 21.8816 4.85394 22.138 5.17632 22.269C5.85092 22.5431 6.60428 22.177 6.85911 21.4515L6.92223 21.2716C7.32585 19.6242 7.92215 18.0114 8.66739 16.4732C9.41353 14.935 10.3083 13.4693 11.3277 12.1086C12.3475 10.7485 13.4929 9.49186 14.7523 8.38739C16.0114 7.2843 17.3868 6.3321 18.8597 5.61705L18.8657 5.61414C19.2422 5.43042 19.4242 4.96018 19.2732 4.5403Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1c990f5a.svg";
export { ForwardRef as ReactComponent };